module.exports = __webpack_public_path__ + "img/phone.0bb7b481.svg";